import { css } from '@emotion/react'
import styled from '@emotion/styled'

interface LoadingOverlayProps {
  isFetching: boolean
}

const LoadingOverlay = styled.div<LoadingOverlayProps>`
  opacity: 0;
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  transition: opacity ease-in-out 0.3s;
  z-index: 1;
  pointer-events: none;

  ${({ isFetching }) =>
    isFetching &&
    css`
      opacity: 0.5;
    `}
`

export default LoadingOverlay
